import { HttpErrorResponse } from '@angular/common/http';
import { CustomerContact } from 'src/app/api';
import { IController, IFormController } from 'angular';
import { Observable } from 'rxjs';
import { BaseModalController } from '../../../base-modal.controller';

export class EditarCriarContatoController extends BaseModalController implements IController {

  /*@ngInject*/ constructor(
    private $mdToast,
    $uibModalInstance,
    public contato: CustomerContact,
    public saveFunction: (contactData: CustomerContact) => Observable<CustomerContact>,
  ) {
    super($uibModalInstance);
  }

  public salvar(form: IFormController) {
    if (form.$invalid) {
      return;
    }

    this.saveFunction(this.contato).subscribe(
      () => this.$uibModalInstance.close({}),
      (err: HttpErrorResponse|Error) => {
        if (err instanceof Error) {
          return;
        }

        if (err.error && err.error.data && err.error.data.error && err.error.data.error.message) {
          this.showAlert(err.error.data.error.message);
        }
      }
    );
  }

  private showAlert(content) {
    const toast = this.$mdToast.simple()
      .textContent(content)
      .highlightAction(true)
      .parent('[data-container="toast"]')
      .position('top right')
      .hideDelay(5000);

    return this.$mdToast.show(toast);
  }
}
